import React from "react";
import { 
  FaCreditCard, 
  FaMoneyBillWave, 
  FaUsers, 
  FaPiggyBank, 
  FaMoneyCheck, 
  FaSave 
} from "react-icons/fa";

const products = [
  {
    icon: <FaMoneyBillWave />,
    title: "Money Transfer & Payments",
    desc: "Move money instantly - Anytime, anywhere. No network barriers. Send money, pay contributions, settle group obligations, and make personal payments securely across networks. Fast, affordable, and fully interoperable."
  },
  {
    icon: <FaUsers />,
    title: "Group & Personal Merry Go Round (MGR)",
    desc: "Smart Merry Go Rounds for groups and individuals. Run classic group MGRs or start digital merry-go-rounds with virtual members to boost your savings discipline. Flexible modes: manual or automatic, based on user preference."
  },
  {
    icon: <FaPiggyBank />,
    title: "Digital Table Banking",
    desc: "Table banking without physical meetings. Groups create cycles, review table loan requests, and auto-disburse loans — even when members are offline. MastaKash automates loan allocation, scheduling, repayments, and reporting."
  },
  {
    icon: <FaMoneyCheck />,
    title: "Personal Finance for Individuals",
    desc: "Your entire financial life - in one dashboard. Save, set goals, track spending, receive payouts, join groups, pay bills, send money, and manage your wallet — all inside MastaKash."
  },
  {
    icon: <FaSave />,
    title: "Saving & Credit (For SACCOS & Groups)",
    desc: "Fully automated savings and credit infrastructure. Supports structured plans, member contributions, loan products, welfare funds, and emergency contributions with end-to-end automation and real-time transparency."
  },
  {
    icon: <FaCreditCard />,
    title: "Sukuma Overdraft",
    desc: "Instant small value overdrafts to cushion your finances. A smart overdraft for verified members — designed to prevent financial shocks and uplift credit access responsibly."
  },
];

export default function Products() {
  return (
    <section className="w-full bg-white py-16 px-4" id="products">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white bg-purple-600 inline-block px-6 py-3 rounded-lg">
            Products & Services
          </h2>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, idx) => (
            <div 
              key={idx} 
              className="bg-purple-50 p-6 rounded-2xl shadow-md hover:shadow-lg transition flex flex-col gap-4"
            >
              <div className="text-purple-700 text-5xl">{product.icon}</div>
              <h3 className="text-black font-bold text-xl">{product.title}</h3>
              <p className="text-gray-700 text-sm leading-relaxed">{product.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
